//import * as Helper from "../../../../utils/Helper";
import ApiService from "../../../ApiService";

const EditService = {
    loadScreenView: (id, successCallback, failureCallback) => {
        ApiService.post("/web/admin/unittype/edit/loadscreenview", { id }, successCallback, failureCallback);
    },
    saveUnitType: (vo, successCallback, failureCallback) => {
        ApiService.post("/web/admin/unittype/edit/save", vo, successCallback, failureCallback);
    },
    uploadPhoto: (file, id, successCallback, failureCallback) => {
        let formData = new FormData();
        formData.append("fileData", file);
        formData.append("table", "UnitTypes");
        formData.append("field", "Photo");
        formData.append("id", id);
        ApiService.postFileToServer("/common/file/upload", formData, successCallback, failureCallback);
    }
};

export default EditService;